<section class="files-session">
    <div class="page-title-area">
        <div class="container">
            <div class="page-title-content">
                <h2>{{ title }}</h2>
            </div>
        </div>
    </div>
    <section class="ptb-100">
        <div class="container pdf-container">
            <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"></pdf-viewer>
        </div>
    </section>
</section>
